import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RetrieveApplRequest } from 'app/applications/landing-page.service';
import { environment } from '../../environments/environment';

import { catchError, map, Observable, throwError } from 'rxjs';
import { AlertMessagesConfig } from 'config/alert-messages.config';
import { ApplicationInfoModel } from 'app/models/application-info.model';

export interface RetrieveUsanUserApplRequest {
  orgId:string;
  ssoId:string;
  status: string[];
}

export type RetrieveUsanUserApplResponse = {
  Data: ApplicationInfoUserUsanModel[];
  Errors: [],
  ErrorMessage: string
}
export class ApplicationInfoUserUsanModel extends ApplicationInfoModel {
   
   formTypeDesc?: string;
   applicantFirstName?: string;
   applicantLastName?: string;
   firstSuggestedName?: string;
   negotiatorShort?: string;
}

export const formTypeMap = { 
    'A': 'Form A - Single Entity Drug and Salt',
    'B': 'Form B - Single Entity' ,
    'C': 'Form C - Modified Salt Form' ,
    'D': 'Form D - USAN Revised Application' ,
    'E': 'Form E - Contact Lens Material' ,
    'F': 'Form F - Biologics' 
  };

@Injectable({
  providedIn: 'root'
})
export class UserDashboardService {
  // private apiUrl = environment.apiUrl;
  constructor(
    private http: HttpClient,
    public alertsMessageConfig: AlertMessagesConfig,
  ) { }

  public fetchApplicationsUsanUser(req: RetrieveUsanUserApplRequest): Observable<RetrieveUsanUserApplResponse> {
    return this.http.post<any>('usanapi/dashboard/usanuser', req)
     .pipe(
        map(response => {
          // console.log (`response ${JSON.stringify(response)}`)
          return response;
        }),
        catchError(() => {
          return throwError(() => new Error(this.alertsMessageConfig.defaultServerError));
        }));
  }
  public mapToApplicationUserModelArray(data): ApplicationInfoUserUsanModel[] {
    const array: ApplicationInfoUserUsanModel[] = [];
    for(const d of data) {
        array.push(this.parseValues(d));
    }
    return array;
  }
  private parseValues(json: any): ApplicationInfoUserUsanModel {
    let rec:ApplicationInfoUserUsanModel = ApplicationInfoModel.parseAPIValues(json);
    if (rec.form) {
      rec.formTypeDesc = formTypeMap[rec.form.trim()];
    }
    rec.applicantFirstName = json.u_usan_applicant_firstname;
    rec.applicantLastName = json.u_usan_applicant_lastname;
    rec.firstSuggestedName = rec.suggestedNames?.[0];
    rec.negotiatorShort = rec.negotiator ? this.splitFirstLetter(rec.negotiator) : ' ';
    return rec;
  }
  private splitFirstLetter(str: string): string{
    const trimmed = str.trim();
    const words = trimmed.split(/\s+/); // split by any amount of whitespace
    const firstLetter = words[0]?.charAt(0) || "";
    const rest = words.slice(1).join(" "); // rest of string without the first word
    return  firstLetter + '. ' + rest ;
  }

}
